import { Pencil } from "lucide-react";
import { isPlanExpired } from "../../utils/helper";
import { trackAnalyticsEvent } from "../../utils/analytics";

function ThumbnailCard({
    item,
    filename,
    index,
    downloadCardLoading,
    isPercentDownloading,
    isEdit,
    loading,
    navigate,
    handleDownload,
    store,
    id,
    planDetails
}) {
    return (
        <div
            key={filename + "_" + index}
            className="artboard--main__export--teeshirts--item"
        >
            <div className="artboard--main__export--teeshirts--text">
                <h4>{filename}</h4>
            </div>
            <div className="artboard--main__export--teeshirts--img"  style={{border: '1px solid #ccc', borderRadius: '11.5px'}}>
                {item.base64.length > 0 ? (
                    <img src={item?.base64} alt={filename} />
                ) : (
                    <div
                        style={{
                            width: "100%",
                            height: "280px",
                        }}
                    >
                        <div className="skeleton skeleton-img" />
                    </div>
                )}
                <div className="artboard--main__export--teeshirts--actions">
                    <button
                        onClick={() => {
                            trackAnalyticsEvent("export_thumbnail_edit_click", {
                                index,
                                file_name: filename,
                                design_id: id,
                            });
                            navigate(
                                `/edittshirt/${store?.pages?.findIndex(
                                    (page) =>
                                        parseInt(page?.id) ===
                                        parseInt(item?.indexSr)
                                )}/${id}`
                            );
                        }}
                        disabled={
                            (downloadCardLoading.index === index &&
                                downloadCardLoading.loading) ||
                            isPercentDownloading ||
                            (isEdit && loading)
                        }
                        className="button-common button--light"
                    >
                        <Pencil size={14} style={{ marginRight: 8 }} /> Edit
                    </button>
                    <button
                        disabled={
                            (downloadCardLoading.index === index &&
                                downloadCardLoading.loading) ||
                            isPercentDownloading ||
                            (isEdit && loading) ||
                            isPlanExpired(planDetails)
                        }
                        onClick={() => handleDownload(index, item, filename)}
                        className="button-common button--dark"
                    >
                        {downloadCardLoading.index === index &&
                        downloadCardLoading.loading
                            ? "Loading..."
                            : "Download"}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ThumbnailCard;
